import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import getCookie from '../Queries/getCookie';

import html2pdf from 'html2pdf.js';

import styles from './index.module.sass';

export default function DownloadOrder({ orderData }) {
  const { t } = useTranslation('order');

  const { domicilioEnvio = {} } = orderData;

  function fromHTML(html, trim = true) {
    // Process the HTML string.
    html = trim ? html.trim() : html;
    if (!html) return null;

    // Then set up a new template element.
    const template = document.createElement('template');
    template.innerHTML = html;
    const result = template.content.children;

    // Then return either an HTMLElement or HTMLCollection,
    // based on whether the input HTML had one or more roots.
    if (result.length === 1) return result[0];
    return result;
  }

  const downloadOrder = useCallback(() => {
    const date = new Date();
    let orderHTML = `
    <div style="padding: 24px; font-family: Arial, Helvetica, sans-serif">
      <div
        style="
          font-weight: 600;
          font-size: 18px;
          display: flex;
          justify-content: center;
          margin-bottom: 16px;
        "
      >
        Terramar Brands
      </div>
      <div style="margin: 16px 0px">
        <div style="font-weight: 600; font-size: 18px">${t('order')}: ${
      orderData?.folioPedido
    }</div>
        <div style="font-weight: 600; font-size: 18px">Kit: ${getCookie('usuario') ?? ''} ${
      getCookie('kitName') ?? ''
    }</div>
      
      <div style="font-weight: 600; font-size: 18px">${t('date')}: ${date.getFullYear()}/${
      date.getMonth() + 1
    }/${date.getDate()}-${date.getHours()}:${date.getMinutes()}</div>
      </div>
      <div style="margin-bottom: 8px">
        <div>
          ${domicilioEnvio?.calle || ''} ${domicilioEnvio?.entreCalle || ''} ${
      domicilioEnvio?.numeroExterior || ''
    }
        </div>
        <div>
          ${domicilioEnvio?.municipio || ''}, ${domicilioEnvio?.colonia || ''}
        </div>
        <div>PC ${domicilioEnvio?.cp || ''}</div>
        <div>${t('parcel')}: ${orderData?.domicilioEnvio?.paqueteria}</div>
      </div>
      <table
        style="
          border: 1px solid black;
          border-right: 0px;
          border-bottom: 0px;
          width: 100%;
          border-collapse: collapse;
        "
      >
        <tr>
          <td
            style="
              border: 1px solid black;
              border-left: 0px;
              border-top: 0px;
              font-weight: 600;
              padding: 4px 8px;
              font-size: 16px;
              text-align: center;
              box-sizing: border-box;
            "
          >
            ${t('id')}
          </td>
          <td
            style="
              border: 1px solid black;
              border-left: 0px;
              border-top: 0px;
              font-weight: 600;
              padding: 4px 8px;
              font-size: 16px;
              text-align: center;
              box-sizing: border-box;
            "
          >
            ${t('description')}
          </td>
          <td
            style="
              border: 1px solid black;
              border-left: 0px;
              border-top: 0px;
              font-weight: 600;
              padding: 4px 8px;
              font-size: 16px;
              text-align: center;
              box-sizing: border-box;
            "
          >
            ${t('quantity')}
          </td>
          <td
            style="
              border: 1px solid black;
              border-left: 0px;
              border-top: 0px;
              font-weight: 600;
              padding: 4px 8px;
              font-size: 16px;
              text-align: center;
              box-sizing: border-box;
            "
          >
            ${t('price')}
          </td>
          <td
            style="
              border: 1px solid black;
              border-left: 0px;
              border-top: 0px;
              font-weight: 600;
              padding: 4px 8px;
              font-size: 16px;
              text-align: center;
              box-sizing: border-box;
            "
          >
            ${t('amount')}
          </td>
          
        </tr>
    `;

    for (let i = 0; i < orderData.detallePedido.length; i++) {
      orderHTML += `
      <tr>
      <td
        style="
          border: 1px solid black;
          border-left: 0px;
          border-top: 0px;
          padding: 4px 8px;
          font-size: 16px;
          text-align: center;
          box-sizing: border-box;
        "
      >
        ${orderData.detallePedido[i].clave}
      </td>
      <td
        style="
          border: 1px solid black;
          border-left: 0px;
          border-top: 0px;
          padding: 4px 8px;
          font-size: 16px;
          text-align: center;
          box-sizing: border-box;
        "
      >
        ${orderData.detallePedido[i].descri}
      </td>
      <td
        style="
          border: 1px solid black;
          border-left: 0px;
          border-top: 0px;
          padding: 4px 8px;
          font-size: 16px;
          text-align: center;
          box-sizing: border-box;
        "
      >
        ${orderData.detallePedido[i].cantidad}
      </td>
      <td
        style="
          border: 1px solid black;
          border-left: 0px;
          border-top: 0px;
          padding: 4px 8px;
          font-size: 16px;
          text-align: center;
          box-sizing: border-box;
        "
      >
        ${orderData.detallePedido[i].precio}
      </td>
      <td
        style="
          border: 1px solid black;
          border-left: 0px;
          border-top: 0px;
          padding: 4px 8px;
          font-size: 16px;
          text-align: center;
          box-sizing: border-box;
        "
      >
        ${orderData.detallePedido[i].importe}
      </td>
      
    </tr>`;
    }

    orderHTML += `
      </table>

      <div style="margin: 16px 0px">
        <div style="font-weight: 600; font-size: 18px">${t('subtotal')}: $${
      orderData?.totales?.subtotal
    }</div>
        <div style="font-weight: 600; font-size: 18px">${t('taxes')}: $${
      orderData?.totales?.iva
    }</div>
        <div style="font-weight: 600; font-size: 18px">${t('total')}: $${
      orderData?.totales?.total
    }</div> 
        <div style="font-weight: 600; font-size: 18px">
          ${t('amountToPay')}: $${orderData?.totales?.importeAPagar}
        </div>
      </div>
    </div>
    `;

    var opt = {
      filename: `Pedido-${orderData?.folioPedido}`,
    };
    const orderHTMLFormated = fromHTML(orderHTML);
    var element = orderHTMLFormated;
    html2pdf().from(element).set(opt).save();
  }, [
    domicilioEnvio?.calle,
    domicilioEnvio?.colonia,
    domicilioEnvio?.cp,
    domicilioEnvio?.entreCalle,
    domicilioEnvio?.municipio,
    domicilioEnvio?.numeroExterior,
    orderData.detallePedido,
    orderData?.domicilioEnvio?.paqueteria,
    orderData?.folioPedido,
    orderData?.totales?.importeAPagar,
    orderData?.totales?.iva,
    orderData?.totales?.subtotal,
    orderData?.totales?.total,
    t,
  ]);

  return (
    <div className={styles.dowloadOrder} onClick={() => downloadOrder()}>
      <i className={`material-icons ${styles.dowloadIcon}`}>file_download</i>
      <div className={styles.line}>{t('download')}</div>
    </div>
  );
}
